module.exports = function(obj) {
obj || (obj = {});
var __t, __p = '';
with (obj) {
__p += '<div class="dialog-wrapper"><div class="dialog modal-dialog dialog-edu-global"><div class="dialog-mask"></div><div class="dialog-main"><button class="vertical-a iconfont icon-close close-edu-global">x</button><div class="dialog-body"><div class="add-form-dialog-body"><div class="title">教育專業版認證申請</div><div class="body"><p>請準備好如下材料信息，通過郵箱 support@umu.com 聯繫UMU免費升級為教育專業版。</p><p>1. 已註冊的UMU賬戶信息（用戶名、郵箱或手機號信息）。</p><p>2. 在職教師工作證或其他可以證明您身份的在職證明。</p></div><div class="footer"><button class="btn-confirm close-edu-global">知道了</button></div></div></div></div></div></div>\n';

}
return __p
}